/**
 * Helpers for dashboard keyword arrays (GET/POST/PATCH).
 * On create, omit keywords when empty so the backend can LLM-extract from title+description.
 */

/** Normalize API keyword payloads into a clean string[]. */
export function normalizeDashboardKeywords(raw) {
  if (raw == null) return [];
  if (typeof raw === "string") {
    return parseKeywordsInput(raw);
  }
  if (!Array.isArray(raw)) return [];
  const out = [];
  const seen = new Set();
  for (const item of raw) {
    const value =
      typeof item === "string"
        ? item.trim()
        : item != null && typeof item === "object"
          ? String(item.keyword ?? item.name ?? item.value ?? "").trim()
          : String(item ?? "").trim();
    if (!value) continue;
    const key = value.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(value);
  }
  return out;
}

/** Parse comma / newline separated keyword text into string[]. */
export function parseKeywordsInput(text) {
  if (text == null) return [];
  return normalizeDashboardKeywords(
    String(text)
      .split(/[\n,]+/)
      .map((s) => s.trim())
      .filter(Boolean)
  );
}

export function formatKeywordsForInput(keywords) {
  return normalizeDashboardKeywords(keywords).join(", ");
}

/** Keywords from a create/update or extract-keywords API response body. */
export function keywordsFromDashboardResponse(responseData) {
  if (responseData == null) return [];
  if (Array.isArray(responseData)) return normalizeDashboardKeywords(responseData);
  return normalizeDashboardKeywords(
    responseData.keywords ??
      responseData.data?.keywords ??
      responseData.dashboard?.keywords ??
      responseData.result?.keywords
  );
}
